import { render, staticRenderFns } from "./OrgSettingsModal.vue?vue&type=template&id=0693856e"
import script from "./OrgSettingsModal.vue?vue&type=script&lang=js"
export * from "./OrgSettingsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports